import axios from "axios";

const state = {
  email_subscriptions: {
    receive_email_actions_implemented: false,
    receive_email_new_app_features: false,
    receive_email_new_recommendations: false,
  },
  showEmailSubscription: {
    receive_email_actions_implemented: false,
    receive_email_new_app_features: false,
    receive_email_new_recommendations: false,
  },
};

const getters = {
  email_subscriptions: (state) => state.email_subscriptions,
  showEmailSubscription: (state) => state.showEmailSubscription,
};

const mutations = {
  mutateEmailSubscriptionOptions(state, mailOpt) {
    state.email_subscriptions = { ...mailOpt };
  },

  mutateEmailShow(state, showOpt) {
    state.showEmailSubscription = { ...showOpt };
  },

  toggleProp(state, key) {
    console.log(state.email_subscriptions, key);
    state.email_subscriptions.key = !state.email_subscriptions.key;
    console.log(state.email_subscriptions);
  },
};

const actions = {
  async getEmailSubscriptionOptions({ rootGetters, commit, dispatch }) {
    try {
      const res = await axios.get(
        rootGetters.backendURL +
          "/api/user_settings/" +
          rootGetters["oidcStore/oidcUser"].email
      );

      let subscrBool = { ...res.data.settings.email_subscriptions };
      let showMenu = {};
      Object.keys(res.data.settings.email_subscriptions).forEach((k) => {
        showMenu[k] =
          res.data.settings.email_subscriptions[k] === -1 ? false : true;
        subscrBool[k] =
          res.data.settings.email_subscriptions[k] === -1
            ? null
            : Boolean(res.data.settings.email_subscriptions[k]);
      });

      commit("mutateEmailShow", showMenu);
      commit("mutateEmailSubscriptionOptions", subscrBool);
    } catch (err) {
      console.log(err);
      commit("mutateEmailShow", {
        receive_email_actions_implemented: false,
        receive_email_new_app_features: false,
        receive_email_new_recommendations: false,
      });
      commit("mutateEmailSubscriptionOptions", {
        receive_email_actions_implemented: false,
        receive_email_new_app_features: false,
        receive_email_new_recommendations: false,
      });

      dispatch("pushNotification", {
        type: "error",
        label: "Get Email Subscriptions failed",
        text: "Subscription Options unavailable",
        duration: "long",
      });
    }
  },
  async setEmailSubscriptionOptions(
    { rootGetters, commit, getters, dispatch },
    propName
  ) {
    console.log(propName);

    let currState = { ...getters.email_subscriptions };

    let currValOfProp = currState[propName] ? 0 : 1;

    commit("toggleProp", propName);

    let payload = {
      settings: {
        email_subscriptions: {
          [propName]: currValOfProp,
        },
      },
    };

    try {
      const res = await axios.post(
        rootGetters.backendURL +
          "/api/user_settings/" +
          rootGetters["oidcStore/oidcUser"].email,
        payload
      );

      console.log(res.data);
    } catch (err) {
      console.log(err);
      dispatch("pushNotification", {
        type: "error",
        label: "Set mail options error",
        text: "Subscription options could not be submitted",
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
